import { subscription } from 'nike-re-framejs';
import { betslipPicksBySelectionId$$ } from '../subs';

export const betslipPick$$ = (selectionId: string, index: number) =>
    subscription(picksBySelectionId => picksBySelectionId?.get(selectionId), betslipPicksBySelectionId$$(index));
